/**
 * Theme store.
 *
 * Owns the active theme name and applies it to the document whenever it
 * changes. Persisted so the choice survives restarts.
 */
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { applyTheme, availableThemes, type ThemeName } from "@/theme";
import { logger } from "@/services/logger";

interface ThemeState {
  theme: ThemeName;
  available: ThemeName[];
  setTheme: (theme: ThemeName) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "black",
      available: availableThemes,
      setTheme: (theme) => {
        applyTheme(theme);
        logger.info("theme", `Theme set to "${theme}"`);
        set({ theme });
      },
    }),
    {
      name: "seufic.theme",
      storage: createJSONStorage(() => localStorage),
      // Re-apply the persisted theme to the DOM after rehydration.
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme);
      },
    },
  ),
);
